import React from "react";
import { Box, Button, Text, useColorModeValue } from "@chakra-ui/react";
import { FiArrowRight } from "@react-icons/all-files/fi/FiArrowRight";
import { Link as GatsbyLink, graphql, useStaticQuery } from "gatsby";
import { HomePageSectionHeading } from "./HomePage";
import { TutorialCard } from "@components/Tutorials";
import { WistiaEmbed } from "@components/WistiaEmbed";

export function HomePageSoloFeatured() {
  const data = useStaticQuery<Queries.GetFeaturedTutorialsQuery>(graphql`
    query GetFeaturedTutorials {
      course(slug: { eq: "connectors-intro-rest" }) {
        ...HomePageTutorial
      }
    }
  `);
  const main_CTA_outline = useColorModeValue("blue.400", "orange.400");
  const main_CTA_BG = useColorModeValue("blue.100", "transparent");

  const tutorial = data.course;
  return (
    tutorial && (
      <Box
        display="flex"
        flexDirection={{
          base: "column",
          md: "column",
        }}
        gap={{
          base: "6",
          lg: "10",
        }}
        padding={2}
        alignItems="center"
        justifyContent="center"
      >
        <Text
          as="h2"
          fontSize={{ base: "2xl", md: "4xl" }}
          lineHeight={{ base: "1.8rem", md: "2rem" }}
          fontWeight={600}
          textAlign="center"
        >
          New on Odyssey: GraphQL ❤️ REST
        </Text>
        <Box width="full" height="auto">
          <WistiaEmbed
            handleVideoData={() => null}
            id="pnjvap0w1e"
            pip={false}
          />
        </Box>
        <Box
          display="flex"
          flexDir="column"
          justifyContent="center"
          alignItems="center"
          gap={{
            base: "4",
            lg: "6",
          }}
          width="100%"
        >
          <Text
            display={{ base: "none", md: "block" }}
            fontSize="2xl"
            lineHeight="1.8rem"
            fontWeight={500}
            textAlign="center"
          >
            Learn how to use Apollo Connectors—the quickest way to get started
            with GraphQL using existing REST APIs! API orchestration has never
            been easier.
          </Text>

          <Text
            display={{ base: "block", md: "none" }}
            fontSize="xl"
            lineHeight="1.8rem"
            fontWeight={500}
            textAlign="center"
          >
            Apollo Connectors: the quickest way to get started with GraphQL and
            REST APIs!
          </Text>

          <Button
            size="lg"
            as={GatsbyLink}
            to="/connectors-intro-rest"
            color={main_CTA_outline}
            borderColor={main_CTA_outline}
            bg={main_CTA_BG}
            borderRadius={"full"}
            variant="outline"
            rightIcon={<FiArrowRight />}
          >
            Start the Connectors course now!
          </Button>
        </Box>
      </Box>
    )
  );
}
